
import React from 'react';
import PropTypes from 'prop-types';

const DayofIcon = ({ className }) => {
  return (
    <svg 
    width="72" 
    height="72" 
    viewBox="0 0 72 72" 
    className={`fill-current ${className}`} 
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor" // Ensures the color can be changed dynamically

    >
    <rect width="72" height="72" rx="12" fill="currentColor"/>
    <path d="M41.2898 28.14L41.2198 31.93C41.2098 32.45 41.5398 33.14 41.9598 33.45L44.4398 35.33C46.0298 36.53 45.7698 38 43.8698 38.6L40.6398 39.61C40.0998 39.78 39.5298 40.37 39.3898 40.92L38.6198 43.86C38.0098 46.18 36.4898 46.41 35.2298 44.37L33.4698 41.52C33.1498 41 32.3898 40.61 31.7898 40.64L28.4498 40.81C26.0598 40.93 25.3798 39.55 26.9398 37.73L28.9198 35.43C29.2898 35 29.4598 34.2 29.2898 33.66L28.2698 30.42C27.6798 28.52 28.7398 27.47 30.6298 28.09L33.5798 29.06C34.0798 29.22 34.8298 29.11 35.2498 28.8L38.3298 26.58C39.9998 25.39 41.3298 26.09 41.2898 28.14Z" fill="#F7F6F5"/>
    <path d="M45.4398 44.4702L42.4098 41.4402C42.1198 41.1502 41.6398 41.1502 41.3498 41.4402C41.0598 41.7302 41.0598 42.2102 41.3498 42.5002L44.3798 45.5302C44.5298 45.6802 44.7198 45.7502 44.9098 45.7502C45.0998 45.7502 45.2898 45.6802 45.4398 45.5302C45.7298 45.2402 45.7298 44.7602 45.4398 44.4702Z" fill="#F7F6F5"/>
    </svg> 
  );
};

DayofIcon.propTypes = {
  className: PropTypes.string, // Optional: allows passing Tailwind or custom classes
};

DayofIcon.defaultProps = {
  className: '', // Default to an empty string
};

export default DayofIcon;